import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getFormattedTextEmbeddedinLITag,
	renderQuestionAnswer,
	renderType1TableAnswerForCurrentYear,
	renderType3TableAnswerForCurrentYear
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple8 = ({
	t,
	page10,
	yearFilter
}) => {

	// Wrapper to maintain compatibility with existing calls
	const rendeTableAnswerForCurrentYearWrapper = (qIndex, colNos) => {
		const block = page10[QUES_CODE_PREFIX + qIndex];
		if (block?.keyValueType === 'TYPE_3_TABLE') {
			const type3 = renderType3TableAnswerForCurrentYear(page10, qIndex, colNos);
			if (type3 != null) return type3;
		}
		return renderType1TableAnswerForCurrentYear(page10, 10, qIndex, colNos);
	};

	const renderP8Q1 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Details of Social Impact Assessments (SIA) of projects undertaken by the entity based on applicable laws, in the current financial year.</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Name and brief details of project</th>
								<th>SIA Notification No</th>
								<th>Date of notification</th>
								<th>Whether conducted by independent external agency (Yes / No)</th>
								<th>Results communicated in public domain (Yes / No)</th>
								<th>Relevant Web link</th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-1', ['a', 'b', 'c', 'd', 'e', 'f'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8Q2 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. Provide information on project(s) for which ongoing Rehabilitation and Resettlement (R&R) is being undertaken by your entity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Name of Project for which R&R is ongoing</th>
								<th>State</th>
								<th>District</th>
								<th>No. of Project Affected Families (PAFs)</th>
								<th>% of PAFs covered by R&R</th>
								<th>Amounts paid to PAFs in the FY (In INR)</th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-2', ['', 'a', 'b', 'c', 'd', 'e', 'f'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8Q3 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3. Describe the mechanisms to receive and redress grievances of the community</b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P8-3a'] ?? '')}
				</div>
			</div>
		);
	};

	const renderP8Q4 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page10?.['previousYear']) {
			page10['previousYear'][QUES_CODE_PREFIX + 'P8-4']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>4. Percentage of input material (inputs to total inputs by value) sourced from suppliers:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th className='FY_class white-nowrap'>FY {yearFilter}</th>
								<th className='white-nowrap'>FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Directly sourced from MSMEs/ small producers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P8-4a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P8-4a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Directly from within India</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P8-4b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P8-4b'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8Q5 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page10?.['previousYear']) {
			page10['previousYear'][QUES_CODE_PREFIX + 'P8-5']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>5. Job creation in smaller towns – Disclose wages paid to persons employed (including employees or workers employed on a permanent or non-permanent / on contract basis) in the following locations, as % of total wage cost</b>
				<div className="mt-2">
					<Table bordered size="sm" className="m-0">
						<thead>
							<tr>
								<th>Location</th>
								<th className='FY_class white-nowrap'>FY {yearFilter}</th>
								<th className='white-nowrap'>FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Rural</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P8-5a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P8-5a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Semi-urban</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P8-5b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P8-5b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Urban</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P8-5c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P8-5c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Metropolitan</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P8-5d'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P8-5d'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
					<p className="m-0 italic">(Place to be categorized as per RBI Classification System - rural / semi-urban / urban / metropolitan)</p>
				</div>
			</div>
		);
	};

	const renderP8LIQ1 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-LI1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Provide details of actions taken to mitigate any negative social impacts identified in the Social Impact Assessments (Reference: Question 1 of Essential Indicators above):</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Details of negative social impact identified</th>
								<th>Corrective action taken</th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-LI1', ['a', 'b'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8LIQ2 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-LI2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. Provide the following information on CSR projects undertaken by your entity in designated aspirational districts as identified by government bodies</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>State</th>
								<th>Aspirational District</th>
								<th>Amount spent (In INR)</th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-LI2', ['', 'a', 'b', 'c'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8LIQ3 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-LI3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3.</b>
				{renderQuestionAnswer('(a) Do you have a preferential procurement policy where you give preference to purchase from suppliers comprising marginalized /vulnerable groups? (Yes/No)', currentYearAnswer[QUES_CODE_PREFIX + 'P8-LI3a'] ?? '')}
				{renderQuestionAnswer('(b) From which marginalized /vulnerable groups do you procure?', currentYearAnswer[QUES_CODE_PREFIX + 'P8-LI3b'] ?? '')}
				{renderQuestionAnswer('(c) What percentage of total procurement (by value) does it constitute?', currentYearAnswer[QUES_CODE_PREFIX + 'P8-LI3c'] ?? '')}
			</div>
		);
	};

	const renderP8LIQ4 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-LI4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>4. Details of the benefits derived and shared from the intellectual properties owned or acquired by your entity (in the current financial year), based on traditional knowledge:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Intellectual Property based on traditional knowledge</th>
								<th>Owned/ Acquired (Yes/No)</th>
								<th>Benefit shared (Yes / No)</th>
								<th>Basis of calculating benefit share</th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-LI4', ['', 'a', 'b', 'c', 'd'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8LIQ5 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-LI5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>5. Details of corrective actions taken or underway, based on any adverse order in intellectual property related disputes wherein usage of traditional knowledge is involved</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Name of authority</th>
								<th>Brief of the Case</th>
								<th>Corrective action taken</th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-LI5', ['a', 'b', 'c'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP8LIQ6 = () => {
		const currentYearAnswer = {};
		if (page10?.['currentYear']) {
			page10['currentYear'][QUES_CODE_PREFIX + 'P8-LI6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>6. Details of beneficiaries of CSR Projects</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>CSR Project</th>
								<th>No. of persons benefitted from CSR Projects</th>
								<th>% of beneficiaries from vulnerable and marginalized groups</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{rendeTableAnswerForCurrentYearWrapper('P8-LI6', ['', 'a', 'b', 'c', 'd'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	return (
		<section id="PRINCIPLE_8" className="Main_Section PRINCIPLE_8">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head mb-3">
						<h5>PRINCIPLE 8 Businesses should promote inclusive growth and equitable development</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Essential Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP8Q1()}
									{renderP8Q2()}
									{renderP8Q3()}
									{renderP8Q4()}
									{renderP8Q5()}
								</div>
							</div>
						</section>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Leadership Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP8LIQ1()}
									{renderP8LIQ2()}
									{renderP8LIQ3()}
									{renderP8LIQ4()}
									{renderP8LIQ5()}
									{renderP8LIQ6()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple8);
